import { IProduct, IProductById } from '../../types/analytics';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/actionGenerator';

export enum EAnalyticsActions {
  SetProducts = 'ANALYTICS/SET_PRODUCTS',
}

interface IProductsPayload {
  products: IProduct[];
  productsById: IProductById;
}

export type TSetProductsAction = ITypedReduxAction<EAnalyticsActions.SetProducts, IProductsPayload>;

export const setProducts = actionGenerator<EAnalyticsActions.SetProducts, IProductsPayload>(
  EAnalyticsActions.SetProducts,
);

export type TAnalyticsActions = TSetProductsAction;
